import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VContainer,
    { attrs: { fluid: "", "grid-list-xl": "" } },
    [
      _c("app-mapeamento", {
        attrs: {
          fim: _vm.mapeamento.fimPerRespGestor,
          inicio: _vm.mapeamento.inicioPerRespGestor,
          acesso: "COMUM",
          titulo: "Competências Técnicas",
        },
        scopedSlots: _vm._u([
          {
            key: "body",
            fn: function () {
              return [
                _vm.usuarioMapeamento.tipo === "REGULAR" &&
                (_vm.chefia || _vm.substituicaoChefia)
                  ? _c(
                      VCol,
                      { attrs: { centered: "", cols: "12", "no-gutters": "" } },
                      [
                        _vm.prazoAtual || _vm.prazoEsgotado
                          ? _c(
                              VRow,
                              { attrs: { "no-gutters": "" } },
                              [
                                _c(
                                  VCol,
                                  [
                                    _vm.prazoAtual
                                      ? _c(
                                          VForm,
                                          {
                                            ref: "form",
                                            model: {
                                              value: _vm.valid,
                                              callback: function ($$v) {
                                                _vm.valid = $$v
                                              },
                                              expression: "valid",
                                            },
                                          },
                                          [
                                            _c(
                                              VRow,
                                              { attrs: { dense: "" } },
                                              [
                                                _c(
                                                  VToolbar,
                                                  { attrs: { flat: "" } },
                                                  [
                                                    _c(VToolbarTitle, [
                                                      _c(
                                                        "h2",
                                                        {
                                                          staticClass:
                                                            "title primary--text text--darken-1 text-no-wrap mt-0",
                                                        },
                                                        [
                                                          _vm._v(
                                                            " CADASTRO DAS RESPONSABILIDADES "
                                                          ),
                                                        ]
                                                      ),
                                                    ]),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                            _c(
                                              VRow,
                                              { attrs: { "no-gutters": "" } },
                                              [
                                                _c(
                                                  VCol,
                                                  { attrs: { cols: "12" } },
                                                  [
                                                    _c(VTextField, {
                                                      attrs: {
                                                        id: "titulo",
                                                        rules:
                                                          _vm.rules
                                                            .responsabilidades,
                                                        color: "primary",
                                                        label:
                                                          "Responsabilidade",
                                                        "prepend-icon": "done",
                                                        required: "",
                                                        tabindex: "1",
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.responsabilidade
                                                            .titulo,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.responsabilidade,
                                                            "titulo",
                                                            typeof $$v ===
                                                              "string"
                                                              ? $$v.trim()
                                                              : $$v
                                                          )
                                                        },
                                                        expression:
                                                          "responsabilidade.titulo",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                            _c(
                                              VRow,
                                              { attrs: { "no-gutters": "" } },
                                              [
                                                _c(
                                                  VCol,
                                                  { attrs: { cols: "6" } },
                                                  [
                                                    _c(VSelect, {
                                                      staticClass: "mr-4",
                                                      attrs: {
                                                        items: _vm.dificuldades,
                                                        rules:
                                                          _vm.rules
                                                            .dificuldades,
                                                        color: "primary",
                                                        "item-text":
                                                          "descricao",
                                                        label:
                                                          "Nível de Dificuldade",
                                                        "prepend-icon":
                                                          "how_to_reg",
                                                        required: "",
                                                        tabindex: "2",
                                                        "return-object": "",
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.responsabilidade
                                                            .dificuldade,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.responsabilidade,
                                                            "dificuldade",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "responsabilidade.dificuldade",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  VCol,
                                                  { attrs: { cols: "6" } },
                                                  [
                                                    _c(VSelect, {
                                                      attrs: {
                                                        items: _vm.impactos,
                                                        rules:
                                                          _vm.rules.impactos,
                                                        color: "primary",
                                                        "item-text":
                                                          "descricao",
                                                        label:
                                                          "Nível de Impacto",
                                                        "prepend-icon":
                                                          "warning",
                                                        required: "",
                                                        tabindex: "3",
                                                        "return-object": "",
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.responsabilidade
                                                            .impacto,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.responsabilidade,
                                                            "impacto",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "responsabilidade.impacto",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                            _c(
                                              VRow,
                                              { attrs: { "no-gutters": "" } },
                                              [
                                                _c(
                                                  VCol,
                                                  { attrs: { cols: "8" } },
                                                  [
                                                    _c(VAutocomplete, {
                                                      staticClass: "mr-4",
                                                      attrs: {
                                                        items:
                                                          _vm.competenciasTecnicas,
                                                        rules:
                                                          _vm.rules
                                                            .competenciasTecnicas,
                                                        "search-input":
                                                          _vm.pesquisaCompetencia,
                                                        chips: "",
                                                        color: "primary",
                                                        "deletable-chips": "",
                                                        "item-text":
                                                          "nomeAtual",
                                                        label:
                                                          "Competências técnicas",
                                                        placeholder:
                                                          "Digite para pesquisar...",
                                                        multiple: "",
                                                        "no-results-text":
                                                          "Nenhum resultado encontrado.",
                                                        "prepend-icon": "build",
                                                        required: "",
                                                        "return-object": "",
                                                        tabindex: "4",
                                                      },
                                                      on: {
                                                        "update:searchInput":
                                                          function ($event) {
                                                            _vm.pesquisaCompetencia =
                                                              $event
                                                          },
                                                        "update:search-input":
                                                          function ($event) {
                                                            _vm.pesquisaCompetencia =
                                                              $event
                                                          },
                                                        change: function (
                                                          $event
                                                        ) {
                                                          _vm.pesquisaCompetencia =
                                                            ""
                                                        },
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "selection",
                                                            fn: function (
                                                              data
                                                            ) {
                                                              return [
                                                                _c(
                                                                  VChip,
                                                                  {
                                                                    staticClass:
                                                                      "chip--select-multi",
                                                                    attrs: {
                                                                      color:
                                                                        data
                                                                          .item
                                                                          .unidades
                                                                          .length ===
                                                                        0
                                                                          ? "secondary"
                                                                          : "grey",
                                                                      "input-value":
                                                                        data.selected,
                                                                      close: "",
                                                                      search:
                                                                        "",
                                                                      "text-color":
                                                                        "white",
                                                                    },
                                                                    on: {
                                                                      "click:close":
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.removeCompetencia(
                                                                            data.item
                                                                          )
                                                                        },
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          data
                                                                            .item
                                                                            .nomeAtual
                                                                        ) +
                                                                        " "
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            },
                                                          },
                                                        ],
                                                        null,
                                                        false,
                                                        3879445122
                                                      ),
                                                      model: {
                                                        value:
                                                          _vm.responsabilidade
                                                            .competenciasTecnicas,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.responsabilidade,
                                                            "competenciasTecnicas",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "responsabilidade.competenciasTecnicas",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  VCol,
                                                  [
                                                    _c(
                                                      VTooltip,
                                                      {
                                                        attrs: { bottom: "" },
                                                        scopedSlots: _vm._u(
                                                          [
                                                            {
                                                              key: "activator",
                                                              fn: function ({
                                                                on,
                                                              }) {
                                                                return [
                                                                  _c(
                                                                    VBtn,
                                                                    _vm._g(
                                                                      {
                                                                        staticClass:
                                                                          "mt-4",
                                                                        attrs: {
                                                                          color:
                                                                            "primary",
                                                                          dark: "",
                                                                          text: "",
                                                                        },
                                                                        on: {
                                                                          click:
                                                                            _vm.toogleCadastroCompetencia,
                                                                        },
                                                                      },
                                                                      on
                                                                    ),
                                                                    [
                                                                      _vm._v(
                                                                        " Adicionar "
                                                                      ),
                                                                      _c(
                                                                        VIcon,
                                                                        {
                                                                          staticClass:
                                                                            "ml-2",
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            " add_circle "
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ],
                                                                    1
                                                                  ),
                                                                ]
                                                              },
                                                            },
                                                          ],
                                                          null,
                                                          false,
                                                          3486685911
                                                        ),
                                                      },
                                                      [
                                                        _c("span", [
                                                          _vm._v(
                                                            "Clique para adicionar uma competência"
                                                          ),
                                                        ]),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                                _c(VSpacer),
                                              ],
                                              1
                                            ),
                                            _c(
                                              VRow,
                                              {
                                                staticClass: "justify-end",
                                                attrs: { "no-gutters": "" },
                                              },
                                              [
                                                _c(
                                                  VTooltip,
                                                  {
                                                    attrs: { top: "" },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "activator",
                                                          fn: function ({
                                                            on,
                                                          }) {
                                                            return [
                                                              _c(
                                                                VBtn,
                                                                _vm._g(
                                                                  {
                                                                    staticClass:
                                                                      "mr-2",
                                                                    attrs: {
                                                                      disabled:
                                                                        !_vm.valid,
                                                                      color:
                                                                        "primary",
                                                                      tabindex:
                                                                        "7",
                                                                    },
                                                                    on: {
                                                                      click:
                                                                        _vm.salvar,
                                                                    },
                                                                  },
                                                                  on
                                                                ),
                                                                [
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        _vm.btnSalvar
                                                                      ) +
                                                                      " "
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          },
                                                        },
                                                      ],
                                                      null,
                                                      false,
                                                      3069768643
                                                    ),
                                                  },
                                                  [
                                                    _c("span", [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            !_vm.isEditando
                                                              ? "Clique no botão para cadastrar uma responsabilidade"
                                                              : "Clique no botão para editar a responsabilidade"
                                                          )
                                                      ),
                                                    ]),
                                                  ]
                                                ),
                                                _c(
                                                  VTooltip,
                                                  {
                                                    attrs: { top: "" },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "activator",
                                                          fn: function ({
                                                            on,
                                                          }) {
                                                            return [
                                                              _c(
                                                                VBtn,
                                                                _vm._g(
                                                                  {
                                                                    attrs: {
                                                                      disabled:
                                                                        !_vm.isFormUpdated,
                                                                      color:
                                                                        "primary",
                                                                      outlined:
                                                                        "",
                                                                    },
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.clearFields()
                                                                        },
                                                                    },
                                                                  },
                                                                  on
                                                                ),
                                                                [
                                                                  _vm._v(
                                                                    " Cancelar "
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          },
                                                        },
                                                      ],
                                                      null,
                                                      false,
                                                      3520028728
                                                    ),
                                                  },
                                                  [
                                                    _c("span", [
                                                      _vm._v(
                                                        "Clique no botão para cancelar a operação"
                                                      ),
                                                    ]),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.prazoAtual || _vm.prazoEsgotado
                          ? _c(
                              VRow,
                              [
                                _c(
                                  VToolbar,
                                  { attrs: { flat: "" } },
                                  [
                                    _c(VToolbarTitle, [
                                      _c(
                                        "h2",
                                        {
                                          staticClass:
                                            "title primary--text text--darken-1 text-no-wrap mb-4",
                                        },
                                        [
                                          _vm._v(
                                            " RESPONSABILIDADES (" +
                                              _vm._s(
                                                _vm.responsabilidades.length
                                              ) +
                                              ") "
                                          ),
                                        ]
                                      ),
                                    ]),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.prazoAtual || _vm.prazoEsgotado
                          ? _c(
                              VRow,
                              { attrs: { "no-gutters": "" } },
                              [
                                _c(
                                  VCol,
                                  { attrs: { cols: "12", md: "4" } },
                                  [
                                    _c("app-sort", {
                                      model: {
                                        value: _vm.opcoes,
                                        callback: function ($$v) {
                                          _vm.opcoes = $$v
                                        },
                                        expression: "opcoes",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(VCol, { attrs: { cols: "0", md: "4" } }),
                                _c(
                                  VCol,
                                  { attrs: { cols: "12", md: "4" } },
                                  [
                                    _c("app-search", {
                                      model: {
                                        value: _vm.opcoes,
                                        callback: function ($$v) {
                                          _vm.opcoes = $$v
                                        },
                                        expression: "opcoes",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _c(
                          VRow,
                          { attrs: { "no-gutters": "" } },
                          [
                            _c(
                              VCol,
                              [
                                _c(VDataTable, {
                                  staticClass: "elevation-0",
                                  attrs: {
                                    headers: _vm.headers,
                                    items: _vm.responsabilidades,
                                    search: _vm.opcoes.pesquisa,
                                    "sort-by": _vm.opcoes.ordenarPor,
                                    "sort-desc": _vm.opcoes.decrescente,
                                    "item-key": "id",
                                    "show-expand": "",
                                    "single-expand": "",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: `item.data-table-expand`,
                                        fn: function ({
                                          item,
                                          expand,
                                          isExpanded,
                                        }) {
                                          return [
                                            _c(
                                              VTooltip,
                                              {
                                                attrs: { top: "" },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "activator",
                                                      fn: function ({ on }) {
                                                        return [
                                                          _c(
                                                            VBtn,
                                                            _vm._g(
                                                              {
                                                                attrs: {
                                                                  height:
                                                                    "100%",
                                                                  text: "",
                                                                  width: "100%",
                                                                },
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      expand(
                                                                        !isExpanded
                                                                      ),
                                                                        _vm.gerarColunas(
                                                                          item.competenciasTecnicas
                                                                        )
                                                                    },
                                                                },
                                                              },
                                                              on
                                                            ),
                                                            [
                                                              _c(
                                                                VBadge,
                                                                {
                                                                  attrs: {
                                                                    right: "",
                                                                  },
                                                                  scopedSlots:
                                                                    _vm._u(
                                                                      [
                                                                        {
                                                                          key: "badge",
                                                                          fn: function () {
                                                                            return [
                                                                              _c(
                                                                                "span",
                                                                                [
                                                                                  _vm._v(
                                                                                    _vm._s(
                                                                                      item
                                                                                        .competenciasTecnicas
                                                                                        .length
                                                                                    )
                                                                                  ),
                                                                                ]
                                                                              ),
                                                                            ]
                                                                          },
                                                                          proxy: true,
                                                                        },
                                                                      ],
                                                                      null,
                                                                      true
                                                                    ),
                                                                },
                                                                [
                                                                  _c(
                                                                    VIcon,
                                                                    {
                                                                      attrs: {
                                                                        color:
                                                                          "grey lighten-0",
                                                                        large:
                                                                          "",
                                                                      },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        " build "
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                        ]
                                                      },
                                                    },
                                                  ],
                                                  null,
                                                  true
                                                ),
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    "Clique para exibir as competências técnicas"
                                                  ),
                                                ]),
                                              ]
                                            ),
                                          ]
                                        },
                                      },
                                      {
                                        key: `expanded-item`,
                                        fn: function ({ headers }) {
                                          return [
                                            _c(
                                              "td",
                                              {
                                                staticClass: "justify-center",
                                                attrs: {
                                                  colspan: headers.length,
                                                },
                                              },
                                              [
                                                _c(
                                                  VRow,
                                                  { attrs: { dense: "" } },
                                                  [
                                                    _c(VSpacer),
                                                    _c(
                                                      VCol,
                                                      [
                                                        _c(
                                                          VRow,
                                                          {
                                                            staticClass:
                                                              "justify-center",
                                                          },
                                                          [
                                                            _c(
                                                              "h2",
                                                              {
                                                                staticClass:
                                                                  "title primary--text text--darken-1 text-no-wrap",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " COMPETÊNCIAS TÉCNICAS "
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                    _c(VSpacer),
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  VRow,
                                                  [
                                                    _c(VSpacer),
                                                    _c(
                                                      VCol,
                                                      { attrs: { cols: "10" } },
                                                      [
                                                        _c(VSimpleTable, {
                                                          staticClass:
                                                            "elevation-0 mb-4",
                                                          attrs: { dense: "" },
                                                          scopedSlots: _vm._u(
                                                            [
                                                              {
                                                                key: "default",
                                                                fn: function () {
                                                                  return [
                                                                    _c(
                                                                      "tbody",
                                                                      _vm._l(
                                                                        _vm
                                                                          .colunas
                                                                          .lista,
                                                                        function (
                                                                          column
                                                                        ) {
                                                                          return _c(
                                                                            "tr",
                                                                            {
                                                                              key: column.id,
                                                                            },
                                                                            _vm._l(
                                                                              column,
                                                                              function (
                                                                                item
                                                                              ) {
                                                                                return _c(
                                                                                  "td",
                                                                                  {
                                                                                    key: item.id,
                                                                                    attrs:
                                                                                      {
                                                                                        width:
                                                                                          "30%",
                                                                                      },
                                                                                  },
                                                                                  [
                                                                                    _c(
                                                                                      "div",
                                                                                      {
                                                                                        staticClass:
                                                                                          "d-flex flex-row ma-1",
                                                                                      },
                                                                                      [
                                                                                        _c(
                                                                                          "span",
                                                                                          {
                                                                                            class:
                                                                                              item.tipo ===
                                                                                              "GERAL"
                                                                                                ? "secondary--text"
                                                                                                : "grey-text text--darken-2",
                                                                                          },
                                                                                          [
                                                                                            _vm._v(
                                                                                              " " +
                                                                                                _vm._s(
                                                                                                  item.nomeAtual
                                                                                                ) +
                                                                                                " "
                                                                                            ),
                                                                                          ]
                                                                                        ),
                                                                                      ]
                                                                                    ),
                                                                                  ]
                                                                                )
                                                                              }
                                                                            ),
                                                                            0
                                                                          )
                                                                        }
                                                                      ),
                                                                      0
                                                                    ),
                                                                  ]
                                                                },
                                                                proxy: true,
                                                              },
                                                            ],
                                                            null,
                                                            true
                                                          ),
                                                        }),
                                                      ],
                                                      1
                                                    ),
                                                    _c(VSpacer),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                      {
                                        key: `item.status`,
                                        fn: function ({ item }) {
                                          return [
                                            _c(
                                              VCol,
                                              [
                                                _c(
                                                  VTooltip,
                                                  {
                                                    attrs: {
                                                      "max-width": "500",
                                                      top: "",
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "activator",
                                                          fn: function ({
                                                            on,
                                                          }) {
                                                            return [
                                                              _c(
                                                                VChip,
                                                                _vm._g(
                                                                  {
                                                                    staticClass:
                                                                      "ml-1",
                                                                    attrs: {
                                                                      color:
                                                                        "success white--text",
                                                                      label: "",
                                                                      small: "",
                                                                    },
                                                                  },
                                                                  on
                                                                ),
                                                                [
                                                                  _vm._v(
                                                                    " Dificuldade " +
                                                                      _vm._s(
                                                                        item
                                                                          .dificuldade
                                                                          .valor
                                                                      ) +
                                                                      " "
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          },
                                                        },
                                                      ],
                                                      null,
                                                      true
                                                    ),
                                                  },
                                                  [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          item.dificuldade
                                                            .descricao
                                                        )
                                                      ),
                                                    ]),
                                                  ]
                                                ),
                                                _c(
                                                  VTooltip,
                                                  {
                                                    attrs: {
                                                      "max-width": "500",
                                                      top: "",
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "activator",
                                                          fn: function ({
                                                            on,
                                                          }) {
                                                            return [
                                                              _c(
                                                                VChip,
                                                                _vm._g(
                                                                  {
                                                                    staticClass:
                                                                      "ml-1",
                                                                    attrs: {
                                                                      color:
                                                                        "secondary white--text",
                                                                      label: "",
                                                                      small: "",
                                                                    },
                                                                  },
                                                                  on
                                                                ),
                                                                [
                                                                  _vm._v(
                                                                    " Impacto " +
                                                                      _vm._s(
                                                                        item
                                                                          .impacto
                                                                          .valor
                                                                      ) +
                                                                      " "
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          },
                                                        },
                                                      ],
                                                      null,
                                                      true
                                                    ),
                                                  },
                                                  [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          item.impacto.descricao
                                                        )
                                                      ),
                                                    ]),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                      {
                                        key: `item.acoes`,
                                        fn: function ({ item }) {
                                          return [
                                            _c(
                                              VCol,
                                              [
                                                _c(
                                                  VTooltip,
                                                  {
                                                    attrs: { left: "" },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "activator",
                                                          fn: function ({
                                                            on,
                                                          }) {
                                                            return [
                                                              _vm.prazoAtual
                                                                ? _c(
                                                                    VBtn,
                                                                    _vm._g(
                                                                      {
                                                                        staticClass:
                                                                          "mr-2",
                                                                        attrs: {
                                                                          color:
                                                                            "secondary",
                                                                          icon: "",
                                                                          small:
                                                                            "",
                                                                        },
                                                                        on: {
                                                                          click:
                                                                            function (
                                                                              $event
                                                                            ) {
                                                                              return _vm.editItem(
                                                                                item
                                                                              )
                                                                            },
                                                                        },
                                                                      },
                                                                      on
                                                                    ),
                                                                    [
                                                                      _c(
                                                                        VIcon,
                                                                        [
                                                                          _vm._v(
                                                                            "edit"
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ],
                                                                    1
                                                                  )
                                                                : _vm._e(),
                                                            ]
                                                          },
                                                        },
                                                      ],
                                                      null,
                                                      true
                                                    ),
                                                  },
                                                  [
                                                    _c("span", [
                                                      _vm._v(
                                                        "Clique no botão para editar a responsabilidade"
                                                      ),
                                                    ]),
                                                  ]
                                                ),
                                                _c(
                                                  VTooltip,
                                                  {
                                                    attrs: { left: "" },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "activator",
                                                          fn: function ({
                                                            on,
                                                          }) {
                                                            return [
                                                              _vm.prazoAtual
                                                                ? _c(
                                                                    VBtn,
                                                                    _vm._g(
                                                                      {
                                                                        attrs: {
                                                                          color:
                                                                            "error",
                                                                          icon: "",
                                                                          small:
                                                                            "",
                                                                        },
                                                                        on: {
                                                                          click:
                                                                            function (
                                                                              $event
                                                                            ) {
                                                                              return _vm.confirmDeleteItem(
                                                                                item
                                                                              )
                                                                            },
                                                                        },
                                                                      },
                                                                      on
                                                                    ),
                                                                    [
                                                                      _c(
                                                                        VIcon,
                                                                        [
                                                                          _vm._v(
                                                                            "delete"
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ],
                                                                    1
                                                                  )
                                                                : _vm._e(),
                                                            ]
                                                          },
                                                        },
                                                      ],
                                                      null,
                                                      true
                                                    ),
                                                  },
                                                  [
                                                    _c("span", [
                                                      _vm._v(
                                                        "Clique no botão para excluir a responsabilidade"
                                                      ),
                                                    ]),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _c(
                      VCol,
                      [
                        _c("app-alert", {
                          attrs: {
                            message: `Usuário não realiza cadastro de responsabilidade.`,
                          },
                        }),
                      ],
                      1
                    ),
              ]
            },
            proxy: true,
          },
          {
            key: "actions",
            fn: function () {
              return [
                _c(VRow, { attrs: { "no-gutters": "" } }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.prazoAtual &&
                            (_vm.chefia || _vm.substituicaoChefia) &&
                            _vm.usuarioMapeamento.tipo === "REGULAR",
                          expression:
                            "prazoAtual && (chefia || substituicaoChefia) && usuarioMapeamento.tipo === 'REGULAR'",
                        },
                      ],
                      staticClass: "text-lg-right mt-3 mb-3",
                    },
                    [
                      _c(
                        VTooltip,
                        {
                          attrs: {
                            disabled: _vm.responsabilidades.length === 0,
                            left: "",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "activator",
                              fn: function ({ on }) {
                                return [
                                  _c(
                                    VBtn,
                                    _vm._g(
                                      {
                                        staticClass: "mr-2",
                                        attrs: {
                                          disabled:
                                            _vm.responsabilidades.length === 0,
                                          color: "secondary",
                                          outlined: "",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.toogleDialogAgradecimento()
                                          },
                                        },
                                      },
                                      on
                                    ),
                                    [
                                      _vm._v(" Finalizar "),
                                      _c(VIcon, { staticClass: "ml-2" }, [
                                        _vm._v(" check "),
                                      ]),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ]),
                        },
                        [
                          _c("span", [
                            _vm._v(
                              "Clique no botão para finalizar o Cadastro das Responsabilidades"
                            ),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                ]),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("dialog-remove", {
        attrs: {
          "confirm-action": _vm.deleteItem,
          "dialog-visible": _vm.dialogRemove.visible,
          "toogle-visible": _vm.toogleDialogRemove,
          descricao: "Você realmente deseja excluir essa responsabilidade?",
        },
      }),
      _c("dialog-agradecimento", {
        attrs: {
          "dialog-visible": _vm.dialogAgradecimento.visible,
          "toogle-visible": _vm.toogleDialogAgradecimento,
          descricao:
            "Agradecemos pela sua colaboração!\n              Você ainda poderá participar do Cadastro das Responsabilidades até o período estabelecido.",
          "url-redirecionamento": "/mapeamento",
        },
      }),
      _c("cadastro-edicao-competencia", {
        attrs: {
          competencia: _vm.competencia,
          "is-edicao": false,
          mapeamento: _vm.mapeamento,
          toogle: _vm.toogleCadastroCompetencia,
          visibilidade: _vm.dialogCompetencia,
          etapa: "cadastro",
        },
        on: {
          hide: _vm.toogleCadastroCompetencia,
          return: (value) => _vm.addCompetencia(value),
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }